import { takeEvery, call } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'
import { AxiosError } from 'axios'

import {
  RecordBulkUpdateAction,
  RECORD_BULK_UPDATE,
  BulkUpdateResponse
} from './actions'
import { handleApiFailure } from 'portal/lib/sharedComponents/apiFailureHandler'

function* editRecordBulkUpdateSaga(action: RecordBulkUpdateAction) {
  const {
    accountId,
    projectId,
    moduleName,
    fieldName,
    newValue,
    recordIds,
    showSuccessNotification,
    showFailureNotification,
    allowOverwrite = false
  } = action
  try {
    yield call(() =>
      axios
        .put<BulkUpdateResponse>(
          `/accounts/${accountId}/projects/${projectId}/modules/${moduleName}/bulk-update`,
          {
            fieldName,
            newValue,
            recordIds,
            allowOverwrite
          },
          {
            validateStatus: status => {
              if (status === 200 || status === 201 || status === 204) {
                return true
              }
              return false
            }
          }
        )
        .then(response => {
          const {
            isFullySuccessful,
            recordsRequested,
            recordsSuccessfullyUpdated,
            failures
          } = response.data

          if (isFullySuccessful) {
            showSuccessNotification({
              isFullySuccessful,
              recordsRequested,
              recordsSuccessfullyUpdated,
              failures
            })
          } else {
            console.warn('Partial bulk update failure:', {
              recordsRequested,
              recordsSuccessfullyUpdated,
              failures
            })
            showSuccessNotification({
              isFullySuccessful,
              recordsRequested,
              recordsSuccessfullyUpdated,
              failures
            })
          }
        })
    )
  } catch (error) {
    console.error('Error bulk update of records:', error)
    if (error instanceof AxiosError) {
      handleApiFailure(error)
    } else {
      showFailureNotification()
    }
  }
}

export function* watch() {
  yield takeEvery(RECORD_BULK_UPDATE, editRecordBulkUpdateSaga)
}
